/**
 * Unit (Unidade / posto de trabalho) types
 */

export enum UnitStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const UNIT_STATUS_LABELS: Record<UnitStatus, string> = {
  [UnitStatus.ACTIVE]: 'Ativa',
  [UnitStatus.INACTIVE]: 'Inativa',
};

export interface Unit {
  id: number;
  companyId: number;
  name: string;
  location?: string | null;
  status: UnitStatus;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateUnitRequest {
  name: string;
  companyId: number;
  location?: string;
  status?: UnitStatus;
}

export type UpdateUnitRequest = Partial<CreateUnitRequest>;

export interface UnitFilters {
  search?: string;
  companyId?: number;
  status?: UnitStatus;
}
